import React from 'react';
import PropTypes from 'prop-types';
import { RadioBoxGroup as VDSRadioBoxGroup } from '@vds/radio-boxes';
import styled from 'styled-components';

const StyledRadioBoxGroup = styled(VDSRadioBoxGroup)`
  > div {
    margin-bottom: 12px;
    @media(min-width: 748){
      :last-child,:nth-last-child(2):nth-child(odd) {
        margin-bottom: 0px;
      }
    }
    :nth-child(even) {
      margin-right: 0px;
    }
  }
`;

const RadioBoxGroup = (props) => <StyledRadioBoxGroup {...props} />;

RadioBoxGroup.defaultProps = {};

RadioBoxGroup.propTypes = {
  defaultValue: PropTypes.string,
  orientation: PropTypes.string,
  data: PropTypes.array,
  onChange: PropTypes.func,
};

export { RadioBoxGroup };
